import { IconName } from '@fashionnovateam/nova-ui-toolkit';
import { ItemLeadTime } from './types';

export type BulkFieldInputType =
  | 'text'
  | 'number'
  | 'currency'
  | 'date'
  | 'select'
  | 'exclusivity';

export type BulkFieldConfig = {
  label: string;
  field: keyof ItemLeadTime;
  inputType: BulkFieldInputType;
  placeholder?: string;
  endAdornmentLabel?: string;
  optionsKey?: 'country' | 'shipmentMode';
  icon: IconName;
};

export const BULK_FIELD_OPTIONS: BulkFieldConfig[] = [
  {
    label: 'Country of Origin',
    field: 'country_of_origin',
    inputType: 'select',
    optionsKey: 'country',
    icon: 'map/map-location',
  },
  {
    label: 'Shipment Mode',
    field: 'shipment_mode',
    inputType: 'select',
    optionsKey: 'shipmentMode',
    icon: 'package/package-02',
  },
  {
    label: 'Delivery Date',
    field: 'earliest_custom_cut_delivery_date',
    inputType: 'date',
    icon: 'calendar/calendar-event',
  },
  {
    label: 'Lead Time',
    field: 'custom_cut_lead_time_in_weeks',
    inputType: 'number',
    endAdornmentLabel: 'weeks',
    icon: 'calendar/calendar-timer',
  },
  {
    label: 'FN Exclusivity',
    field: 'exclusivity',
    inputType: 'exclusivity',
    icon: 'lock/lock-close',
  },
  {
    label: 'JR Cost',
    field: 'cost_jr',
    inputType: 'number',
    endAdornmentLabel: '$',
    icon: 'tag',
  },
  {
    label: 'Plus Cost',
    field: 'cost_plus',
    inputType: 'number',
    endAdornmentLabel: '$',
    icon: 'tag',
  },
  {
    label: 'Stock Qty',
    field: 'stock_quantity',
    inputType: 'number',
    endAdornmentLabel: 'units',
    icon: 'package/package-01',
  },
  {
    label: 'Stock Ratio',
    field: 'stock_ratio',
    inputType: 'text',
    placeholder: '0-0-0',
    icon: 'tag',
  },
  {
    label: 'Stock IHD',
    field: 'earliest_IHD_date_to_deliver_stock',
    inputType: 'date',
    icon: 'calendar/calendar-check',
  },
  {
    label: 'Incoming Stock Qty',
    field: 'incoming_stock_quantity',
    inputType: 'number',
    endAdornmentLabel: 'units',
    icon: 'package/package-01',
  },
  {
    label: 'Incoming Stock Ratio',
    field: 'incoming_stock_ratio',
    inputType: 'text',
    placeholder: '0-0-0',
    icon: 'tag',
  },
  {
    label: 'Incoming Stock IHD',
    field: 'incoming_stock_date',
    inputType: 'date',
    icon: 'calendar/calendar-check',
  },
  {
    label: 'JR MOQ',
    field: 'custom_MOQ_jr',
    inputType: 'number',
    endAdornmentLabel: 'units',
    icon: 'package/package-02',
  },
  {
    label: 'Plus MOQ',
    field: 'custom_MOQ_plus',
    inputType: 'number',
    endAdornmentLabel: 'units',
    icon: 'package/package-02',
  },
  {
    label: 'Other Comments',
    field: 'comments',
    inputType: 'text',
    placeholder: 'Add comments',
    icon: 'chat/chat-default',
  },
];
